import { IWidgetEnvironment } from '@nibtravel/shared/util/constants';

/**
 * We currently have two sources of configs.
 * 1. Here for the QQC App and
 * 2. libs/shared/ui/assets/src/config
 *
 * TODO: Need to create a separate lib to allow single source of truth and possibly, deal with partial configs.
 */
export const environment: IWidgetEnvironment = {
  production: true,
  baseHref: '{% baseHref %}',
  contentful: {
    space: 'ofuyl6ahokd8',
    environment: 'master',
    accessToken: '3EFoGFOa0x9gEeYKjwXI_F-7GirhSIhP1oQ_3TczlU8',
    accessTokenPreview: '_yqfDe6xKiqzpk_zfKtcjVUmpPTAa-RTG29e_kbV7LA',
  },
  sumo: {
    endpoint:
      'https://collectors.au.sumologic.com/receiver/v1/http/ZaVnC4dhaV3TrFeXumzZUIzuUh5di8KtpUYLKudfgz1Z2NFUa3gUpfhksjaLCO2rPNlljWo8CIpUpQiug4oC1kTlQNgHMQl4UOdv0lruM_nU2rdSNPHKLQ==',
    interval: 10000,
    sendErrors: true,
    raw: false,
    useIntervalOnly: false,
    batchSize: 2000,
  },
  sv: {
    stage: 'prod',
    production: true,
    brand: 'sv',
    partner: 'SV',
    theme: 'theme--sv',
    title: 'Travel Insurance - Get a quote Now - SuperValu',
    products: {
      url: 'https://products-api-btob.nibtravelinsurance.com',
      version: 'v1',
    },
    quote: {
      url: 'https://quotes-api-btob-ie.nibtravelinsurance.com',
      version: 'v1',
    },
    user: {
      url: 'https://users-api-btob.nibtravelinsurance.com',
      version: 'v1',
    },
    cardToken: {
      url: 'https://cardtoken-api.nibtravelinsurance.com',
    },
    policies: {
      url: 'https://policies-api-btob.nibtravelinsurance.com',
      version: 'v1',
    },
    gtm: 'GTM-59PZ9KN',
    campaignCode: 'SVOnline',
  },
  wn: {
    stage: 'prod',
    production: true,
    brand: 'wn',
    theme: 'theme--sv',
    products: {
      url: 'https://products-api-wn.uat.wng.me',
      version: 'v1',
    },
    quote: {
      url: 'https://quotes-api-wn-au.wng-test.com',
      version: 'v1',
    },
    user: {
      url: 'https://users-api-wn.uat.wng.me',
      version: 'v1',
    },
    cardToken: {
      url: 'https://cardtoken-api.nibtravelinsurance.com',
    },
    policies: {
      url: 'https://policies-api-wn.uat.wng.me',
      version: 'v1',
    },
    gtm: '',
  },
  nibau: {
    stage: 'prod',
    production: true,
    brand: 'nibau',
    theme: 'theme--nibau',
    products: {
      url: 'https://products-api-btob.nibtravelinsurance.com',
      version: 'v1',
    },
    quote: {
      url: 'https://quotes-api-btob-au.nibtravelinsurance.com',
      version: 'v1',
    },
    user: {
      url: 'https://users-api-btob.nibtravelinsurance.com',
      version: 'v1',
    },
    cardToken: {
      url: 'https://cardtoken-api.nibtravelinsurance.com',
    },
    policies: {
      url: 'https://policies-api-btob.nibtravelinsurance.com',
      version: 'v1',
    },
    gtm: '',
  },
  tidau: {
    stage: 'prod',
    production: true,
    brand: 'tidau',
    partner: 'tidau',
    theme: 'theme--tidau',
    title:
      'Travel Insurance | Get an Instant Quote Today | Travel Insurance Direct (TID)',
    purchasePath: 'https://buy.travelinsurancedirect.com.au/quote/turnstile',
    products: {
      url: 'https://api.nibtravelinsurance.com/products',
      version: 'v1',
    },
    quote: {
      url: 'https://api.nibtravelinsurance.com/quotes',
      version: 'v1',
    },
    user: {
      url: 'https://api.nibtravelinsurance.com/users',
      version: 'v1',
    },
    cardToken: {
      url: 'https://cardtoken-api.nibtravelinsurance.com',
    },
    policies: {
      url: 'https://api.nibtravelinsurance.com/policies',
      version: 'v1',
    },
    footprints: {
      url: 'https://api.footprintsnetwork.org',
      version: 'v1',
    },
    kosmos: {
      url: 'https://www.travelinsurancedirect.com.au',
    },
    gtm: 'GTM-N3Z5HC5',
    ga4TagId: 'G-B9SZYT2TEP',
  },
  nsi: {
    stage: 'prod',
    production: true,
    brand: 'nsi',
    partner: 'nsi',
    theme: 'theme--nsi',
    products: {
      url: 'https://products-api-btob.nibtravelinsurance.com',
      version: 'v1',
    },
    quote: {
      url: 'https://quotes-api-btob-ie.nibtravelinsurance.com',
      version: 'v1',
    },
    user: {
      url: 'https://users-api-btob.nibtravelinsurance.com',
      version: 'v1',
    },
    cardToken: {
      url: 'https://cardtoken-api.nibtravelinsurance.com',
    },
    policies: {
      url: 'https://policies-api-btob.nibtravelinsurance.com',
      version: 'v1',
    },
    gtm: '',
  },
  cota: {
    stage: 'prod',
    production: true,
    brand: 'cota',
    partner: 'cota',
    theme: 'theme--cota',
    products: {
      url: 'https://products-api-btob.nibtravelinsurance.com',
      version: 'v1',
    },
    quote: {
      url: 'https://quotes-api-btob-ie.nibtravelinsurance.com',
      version: 'v1',
    },
    user: {
      url: 'https://users-api-btob.nibtravelinsurance.com',
      version: 'v1',
    },
    cardToken: {
      url: 'https://cardtoken-api.nibtravelinsurance.com',
    },
    policies: {
      url: 'https://policies-api-btob.nibtravelinsurance.com',
      version: 'v1',
    },
    gtm: '',
  },
  qan: {
    stage: 'prod',
    production: true,
    brand: 'qan',
    partner: 'qan',
    theme: 'theme--qan',
    products: {
      url: 'https://products-api-mt1.nibtravelinsurance.com',
      version: 'v1',
    },
    quote: {
      url: 'https://quotes-api-mt1.nibtravelinsurance.com',
      version: 'v1',
    },
    user: {
      url: 'https://users-api-mt1.nibtravelinsurance.com',
      version: 'v1',
    },
    cardToken: {
      url: 'https://cardtoken-api.nibtravelinsurance.com',
    },
    policies: {
      url: 'https://policies-api-mt1.nibtravelinsurance.com',
      version: 'v1',
    },
    gtm: '',
  },
};
